import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Globe, CaretDown } from '@phosphor-icons/react';
import { NAV_HEADLINES } from '../data/navLinks';

const pick = (paths) => paths.filter(p => NAV_HEADLINES[p]).map(p => ({ path: p, ...NAV_HEADLINES[p] }));

export const MARKET_GROUPS = [
  { heading: 'Countries We Serve', links: pick(['/usa', '/canada', '/uk', '/australia', '/service-areas']) },
  { heading: 'Specialty Services', links: pick(['/survey-cad-outsourcing', '/gis-mapping-services', '/lidar-point-cloud-to-cad', '/survey-data-conversion', '/civil-3d-survey-drafting',
    '/services/land-surveying/topographic-survey-drafting', '/services/land-surveying/boundary-survey-drafting', '/services/land-surveying/alta-nsps-survey-drafting', '/services/land-surveying/as-built-survey-drafting']) },
];

const tid = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-');

const LinkItem = ({ l, prefix }) => (
  <Link to={l.path} className="group block py-2" data-testid={`${prefix}-${tid(l.name)}`}>
    <span className="block text-sm font-semibold text-zinc-900 group-hover:text-[#3B82F6]">{l.name}</span>
    <span className="block text-xs text-zinc-500 leading-snug mt-0.5">{l.headline}</span>
  </Link>
);

export const MarketsMenu = () => {
  const [open, setOpen] = useState(false);
  const timer = useRef(null);
  const enter = () => { clearTimeout(timer.current); setOpen(true); };
  const leave = () => { timer.current = setTimeout(() => setOpen(false), 150); };
  return (
    <div className="relative hidden lg:block" onMouseEnter={enter} onMouseLeave={leave} onFocus={enter} data-testid="markets-menu">
      <button onClick={() => setOpen(o => !o)} className="flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wider text-zinc-500 hover:text-[#3B82F6] w-full justify-center" data-testid="markets-menu-button" aria-expanded={open}>
        <Globe size={12} /> Markets <CaretDown size={10} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      <div className={`absolute right-0 top-full pt-2 z-50 transition-[opacity,transform] duration-150 ${open ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-1 pointer-events-none'}`} data-testid="markets-panel" onClick={() => setOpen(false)}>
        <div className="bg-white border border-zinc-200 rounded-xl shadow-xl p-5 grid grid-cols-2 gap-6 w-[680px]">
          {MARKET_GROUPS.map(g => (
            <div key={g.heading} className="w-[310px]">
              <p className="text-[10px] font-bold uppercase tracking-wider text-zinc-400 mb-1">{g.heading}</p>
              {g.links.map(l => <LinkItem key={l.path} l={l} prefix="markets-link" />)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const MarketsMobile = () => (
  <div className="px-4 py-3 border-b border-zinc-100" data-testid="mobile-markets">
    {MARKET_GROUPS.map(g => (
      <div key={g.heading} className="mb-2">
        <p className="text-[10px] font-bold uppercase tracking-wider text-zinc-400 mb-1">{g.heading}</p>
        {g.links.map(l => <LinkItem key={l.path} l={l} prefix="mobile-markets-link" />)}
      </div>
    ))}
  </div>
);
